const Map = () => {
  return (
    <div className="contact-map">
      <iframe
        title="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0353651212713!2d73.17508797517849!3d22.31450222967633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc8b3eb23408d%3A0x5ca00f6acdd0821c!2sArunoday%20Society%2C%20Alkapuri%2C%20Vadodara%2C%20Gujarat%20390020!5e0!3m2!1sen!2sin!4v1731583857454!5m2!1sen!2sin"
        width="100%"
        height="500"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Map;
